import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class Logger {
    logs: string[] = [];
    errors: string[] = [];

    public log(message: string): void {
        this.logs.push(message);
    }

    public err(error: object, message: string): void {
        this.errors.push(message);
    }
}
